// extracted by mini-css-extract-plugin
export default {"tips":"Events_tips__sH8ih"};